import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Banner from "./components/Banner";
import SliderContainer from "./components/SliderContainer";

const ContactUs = () => {
  const [isSidebar, setSidebar] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5">
                  <div _ngcontent-ulj-c108 className="d-flex justify-content-center router-outlet">
                    <router-outlet _ngcontent-ulj-c108 />
                    <div _nghost-ulj-c109 className="ng-star-inserted d-flex justify-content-center">
                      <div
                        _ngcontent-ulj-c109
                        className="mb-5 ng-star-inserted w-75"
                      >
                        <div
                          _ngcontent-ulj-c109
                          className="whatsapp_banner ng-star-inserted"
                        >
                          <img
                            _ngcontent-ulj-c109
                            className="w-100"
                            src="https://dabba.b-cdn.net/images/WhatsAppbanner.png"
                            alt="whatsapp"
                            title="whatsapp"
                          />
                        </div>
                        <div _ngcontent-ulj-c109 className="text-center">
                          <span
                            _ngcontent-ulj-c109
                            className="text-center fs-16 mt-2"
                          >
                            Contact Us
                          </span>
                        </div>
                        <div
                          _ngcontent-ulj-c109
                          className="d-flex flex-column mt-3"
                        >
                          <div
                            _ngcontent-ulj-c109
                            className="d-flex sm-flex-column justify-content-center justify-content-between gap-2 sm-fs-13"
                          >
                            <a
                              _ngcontent-ulj-c109
                              className="bg-tab w-100 p-3 rounded d-flex gap-2"
                              href="mailto:Info@kheloyar.net"
                            >
                              <img
                                _ngcontent-ulj-c109
                                alt="mail"
                                title="mail"
                                className="filter-img"
                                src="https://dabba.b-cdn.net/images/EmailContact.svg"
                              />
                              <span
                                _ngcontent-ulj-c109
                                className="email contact-us-btn"
                              >
                                Info@kheloyar.net
                              </span>
                            </a>
                            <div
                              _ngcontent-ulj-c109
                              className="bg-tab rounded w-100 p-3 d-md-flex gap-2 sm-fs-13 pointer"
                            >
                              <img
                                _ngcontent-ulj-c109
                                alt="whatsapp"
                                title="whatsapp"
                                className="filter-img"
                                src="https://dabba.b-cdn.net/images/WhatsappContact.svg"
                              />
                              <span
                                _ngcontent-ulj-c109
                                className="contact-us-btn"
                              >
                                Customer Support
                              </span>
                            </div>
                          </div>
                          <div
                            _ngcontent-ulj-c109
                            className="address_contact mt-3 mb-3"
                          >
                            <img
                              _ngcontent-ulj-c109
                              alt="contact"
                              title="contact"
                              className="filter-img"
                              src="https://dabba.b-cdn.net/images/LocationContact.svg"
                            />
                            <span _ngcontent-ulj-c109 className="sm-fs-13">
                              {" "}
                              Kheloyaar is a product of Kheloyar Group which
                              operates in accordance with the License granted by
                              SVG Gambling Commission under the license{" "}
                            </span>
                          </div>
                        </div>
                        <div _ngcontent-ulj-c109>
                          <div
                            _ngcontent-ulj-c109
                            className="d-flex justify-content-center"
                          >
                            <a
                              _ngcontent-ulj-c109
                              className="d-flex mx-1 ng-star-inserted"
                              href="https://www.facebook.com/kheloyar.official"
                            >
                              <img
                                _ngcontent-ulj-c109
                                className="social2"
                                alt="Facebook"
                                src="https://dabba.b-cdn.net/kheloyaar360.net/banners/223.png"
                                align="Facebook"
                                title="Facebook"
                              />
                            </a>
                            <a
                              _ngcontent-ulj-c109
                              className="d-flex mx-1 ng-star-inserted"
                              href="https://www.youtube.com/channel/UCC-hnRPCNylFw8usx32y8sQ"
                            >
                              <img
                                _ngcontent-ulj-c109
                                className="social2"
                                alt="Youtube"
                                src="https://dabba.b-cdn.net/kheloyaar360.net/banners/224.png"
                                align="Youtube"
                                title="Youtube"
                              />
                            </a>
                            <a
                              _ngcontent-ulj-c109
                              className="d-flex mx-1 ng-star-inserted"
                              href="https://www.instagram.com/kheloyar_club_net/"
                            >
                              <img
                                _ngcontent-ulj-c109
                                className="social2"
                                alt="INSTA"
                                src="https://dabba.b-cdn.net/kheloyaar360.net/banners/225.png"
                                align="INSTA"
                                title="INSTA"
                              />
                            </a>
                            <a
                              _ngcontent-ulj-c109
                              className="d-flex mx-1 ng-star-inserted"
                              href="https://t.me/kheloyarclub"
                            >
                              <img
                                _ngcontent-ulj-c109
                                className="social2"
                                alt="T"
                                src="https://dabba.b-cdn.net/kheloyaar360.net/banners/226.png"
                                align="T"
                                title="T"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default ContactUs;
